import _ from "lodash";
import * as ActionType from "./actionType";

const dispatchWishlist = (dispatch, getState) => {
  let wishlist = window.localStorage.getItem("wishlist");
  if (!_.isEmpty(wishlist)) {
    wishlist = JSON.parse(wishlist);
    const products = _.get(getState(), "product.products.data");
    wishlist = _.filter(wishlist, productId => {
      return _.get(products, productId) !== undefined;
    });
    dispatch({
      type: ActionType.RECEIVE_WISHLIST,
      data: wishlist
    });
  }
};

const addWishlistAction = id => {
  return async dispatch => {
    dispatch({
      type: ActionType.ADD_WISHLIST,
      id: _.toInteger(id)
    });
  };
};

const removeWishlistAction = id => {
  return async dispatch => {
    dispatch({
      type: ActionType.REMOVE_WISHLIST,
      id
    });
  };
};

const clearWishlistAction = () => {
  return async dispatch => {
    dispatch({
      type: ActionType.CLEAR_WISHLIST
    });
  };
};

export { dispatchWishlist, addWishlistAction, removeWishlistAction, clearWishlistAction };



// WEBPACK FOOTER //
// ./src/actions/quotes.js